{/* Quality Process Section */}
const QualityProcessSection = () => {
    const processes = [
      {
        icon: (
          <svg width="32" height="32" fill="none" stroke="#E8611A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
            <path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            <path d="M3 7V5a2 2 0 012-2h2M7 3h2m2 0h2" />
          </svg>
        ),
        title: "Design Thinking",
        description: "Concevoir et créer des parcours digitaux adaptés à chaque besoin."
      },
      {
        icon: (
          <svg width="32" height="32" fill="none" stroke="#E8611A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
            <path d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        ),
        title: "Développement Thinking",
        description: "Construire un socle technique robuste, sécurisé et évolutif."
      },
      {
        icon: (
          <svg width="32" height="32" fill="none" stroke="#E8611A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
            <path d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
          </svg>
        ),
        title: "Déploiement Thinking",
        description: "L'accès à vos besoins 24H/24 et 7J/J constitue notre priorité absolue."
      }
    ];
  
    return (
      <>
        <section style={{ background:'linear-gradient(135deg,#fff7ed 0%,#ffffff 50%,#f8fafc 100%)', padding:'40px 0 36px', position:'relative', overflow:'hidden', fontFamily:"'DM Sans',sans-serif" }}>
          <div style={{ position:'absolute', inset:0, opacity:0.4, pointerEvents:'none', backgroundImage:'radial-gradient(circle,#e2e8f0 1px,transparent 1px)', backgroundSize:'28px 28px' }} />
          <div style={{ position:'absolute', top:'-10%', left:'5%', width:280, height:280, borderRadius:'50%', background:'radial-gradient(circle,rgba(232,97,26,0.15) 0%,transparent 70%)', filter:'blur(50px)', pointerEvents:'none' }} />
          <div style={{ position:'absolute', bottom:'-10%', right:'5%', width:240, height:240, borderRadius:'50%', background:'radial-gradient(circle,rgba(22,163,74,0.10) 0%,transparent 70%)', filter:'blur(50px)', pointerEvents:'none' }} />

          <div style={{ maxWidth:1200, margin:'0 auto', padding:'0 24px', position:'relative', zIndex:1 }}>
            <div style={{ textAlign:'center', marginBottom:28 }}>
              <div style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'6px 18px', borderRadius:999, border:'1px solid rgba(232,97,26,0.3)', background:'rgba(232,97,26,0.08)', marginBottom:14 }}>
                <svg width="11" height="11" viewBox="0 0 24 24" fill="#E8611A"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
                <span style={{ fontSize:'0.68rem', fontWeight:700, color:'#E8611A', letterSpacing:'0.1em', textTransform:'uppercase' }}>Workflow</span>
              </div>
              <h2 style={{ fontSize:'clamp(1.3rem,2.5vw,1.7rem)', fontWeight:800, color:'#1e293b', margin:'0 0 8px' }}>Notre process qualité</h2>
              <div style={{ width:32, height:2, background:'linear-gradient(90deg,#E8611A,#16a34a)', borderRadius:4, margin:'0 auto 10px' }} />
              <p style={{ color:'#64748b', fontSize:'0.88rem', maxWidth:480, margin:'0 auto' }}>Nous concevons des interfaces et expérience utilisateur intuitive.</p>
            </div>

            <div style={{ position:'relative' }}>
              <div style={{ display:'none' }} className="md:block" />
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(240px,1fr))', gap:20 }}>
                {processes.map((process, index) => (
                  <div key={index} style={{ display:'flex', flexDirection:'column', alignItems:'center', textAlign:'center', gap:10 }}
                    onMouseEnter={e => e.currentTarget.querySelector('.proc-circle').style.transform='scale(1.08)'}
                    onMouseLeave={e => e.currentTarget.querySelector('.proc-circle').style.transform='scale(1)'}
                  >
                    <div className="proc-circle" style={{
                      width:70, height:70, borderRadius:'50%',
                      background:'rgba(255,255,255,0.9)',
                      border:'2px solid rgba(232,97,26,0.3)',
                      boxShadow:'0 4px 16px rgba(232,97,26,0.12)',
                      display:'flex', alignItems:'center', justifyContent:'center',
                      transition:'transform .25s',
                    }}>
                      {process.icon}
                    </div>
                    <h3 style={{ fontSize:'1rem', fontWeight:700, color:'#1e293b', margin:0 }}>{process.title}</h3>
                    <p style={{ fontSize:'0.855rem', color:'#64748b', maxWidth:240, margin:0, lineHeight:1.65 }}>{process.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* NigerEmploi Banner */}
        <section style={{ background:'linear-gradient(135deg,#fff7ed 0%,#ffffff 60%,#f8fafc 100%)', padding:'52px 24px', fontFamily:"'DM Sans',sans-serif", position:'relative', overflow:'hidden' }}>
          <div style={{ position:'absolute', inset:0, opacity:0.35, pointerEvents:'none', backgroundImage:'radial-gradient(circle,#e2e8f0 1px,transparent 1px)', backgroundSize:'28px 28px' }} />
          <div style={{ position:'absolute', top:'-20%', left:'-5%', width:320, height:320, borderRadius:'50%', background:'radial-gradient(circle,rgba(232,97,26,0.13) 0%,transparent 65%)', filter:'blur(50px)', pointerEvents:'none' }} />
          <div style={{ position:'absolute', bottom:'-20%', right:'5%', width:260, height:260, borderRadius:'50%', background:'radial-gradient(circle,rgba(59,130,246,0.08) 0%,transparent 65%)', filter:'blur(50px)', pointerEvents:'none' }} />

          <div style={{ maxWidth:1100, margin:'0 auto', position:'relative', zIndex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:32 }}>

            {/* Header */}
            <div style={{ textAlign:'center', display:'flex', flexDirection:'column', alignItems:'center', gap:12 }}>
              <a href="https://nigeremploi.com" target="_blank" rel="noopener noreferrer"
                style={{ display:'inline-flex', alignItems:'center', gap:9, padding:'11px 28px', borderRadius:999, background:'#E8611A', color:'#fff', fontWeight:700, fontSize:'0.85rem', textDecoration:'none', letterSpacing:'0.04em', transition:'background .2s, transform .2s, box-shadow .2s', boxShadow:'0 4px 20px rgba(232,97,26,0.3)' }}
                onMouseEnter={e => { e.currentTarget.style.background='#d4501a'; e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 8px 28px rgba(232,97,26,0.4)'; }}
                onMouseLeave={e => { e.currentTarget.style.background='#E8611A'; e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 4px 20px rgba(232,97,26,0.3)'; }}
              >
                Nigeremploi.com
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
              </a>
              <h2 style={{ fontSize:'clamp(1rem,2vw,1.25rem)', fontWeight:700, color:'#1e293b', margin:0 }}>
                <span style={{ background:'linear-gradient(to right,#E8611A,#d4501a)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>NigerEmploi.com</span> est le 1er site d'emploi et de recrutement en ligne au Niger
              </h2>
            </div>

            {/* Stats grid */}
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:16, width:'100%' }}>
              {[
                { icon: <svg width="28" height="28" fill="none" stroke="#E8611A" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>, value:'27 454', label:'Annonces publiées depuis 2008' },
                { icon: <svg width="28" height="28" fill="none" stroke="#E8611A" strokeWidth="1.8" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>, value:'2 100', label:'Employeurs' },
                { icon: <svg width="28" height="28" fill="none" stroke="#E8611A" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>, value:'48 810', label:'CV en ligne' },
                { icon: <svg width="28" height="28" fill="none" stroke="#E8611A" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>, value:'50 767', label:'Abonnés à la newsletter' },
              ].map((stat, i) => (
                <div key={i} style={{
                  background:'rgba(255,255,255,0.82)', backdropFilter:'blur(12px)',
                  border:'1px solid rgba(0,0,0,0.06)',
                  borderRadius:18, padding:'24px 20px',
                  display:'flex', flexDirection:'column', alignItems:'center', gap:10,
                  boxShadow:'0 4px 16px rgba(0,0,0,0.06)',
                  transition:'transform .2s, box-shadow .2s',
                  cursor:'default',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.boxShadow='0 12px 32px rgba(232,97,26,0.12)'; e.currentTarget.style.borderColor='rgba(232,97,26,0.2)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 4px 16px rgba(0,0,0,0.06)'; e.currentTarget.style.borderColor='rgba(0,0,0,0.06)'; }}
                >
                  <div style={{ width:52, height:52, borderRadius:14, background:'rgba(232,97,26,0.08)', border:'1px solid rgba(232,97,26,0.15)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    {stat.icon}
                  </div>
                  <span style={{ fontSize:'clamp(1.6rem,3vw,2rem)', fontWeight:800, color:'#1e293b', letterSpacing:'-0.02em' }}>{stat.value}</span>
                  <span style={{ fontSize:'0.78rem', color:'#64748b', textAlign:'center', lineHeight:1.4 }}>{stat.label}</span>
                </div>
              ))}
            </div>

          </div>
        </section>
      </>
    );
  };
  
  export default QualityProcessSection;